import { useRef, useState } from "react";
import IndustriesSearch, {
  type IndustrySearchResult,
} from "../_components/tree/IndustriesSearch.tsx";
import IndustriesTree, {
  type IndustriesTreeRef,
} from "../_components/tree/IndustriesTree.tsx";
import SubIndustryDetailPanel from "../_components/tree/SubIndustryDetailPanel.tsx";
import type { GicsTreeNode } from "../_components/types.ts";

interface Props {
  sectors: GicsTreeNode[];
}

export default function IndustriesTreeView({ sectors }: Props) {
  const treeRef = useRef<IndustriesTreeRef>(null);
  const [selectedNodeId, setSelectedNodeId] = useState<string | null>(null);

  const handleSearchSelect = (result: IndustrySearchResult) => {
    treeRef.current?.expandToNode(result.ancestor_ids, result.id);
  };

  const handleNodeClick = (nodeId: string) => {
    setSelectedNodeId(nodeId);
  };

  const handleClosePanel = () => {
    setSelectedNodeId(null);
  };

  const handleFocusNode = (ancestorIds: string[], nodeId: string) => {
    treeRef.current?.expandToNode(ancestorIds, nodeId);
  };

  return (
    <div className="relative flex flex-col h-full">
      <div className="flex justify-end p-4 border border-border bg-card rounded-t-lg">
        <IndustriesSearch onSelect={handleSearchSelect} />
      </div>
      <div className="flex-1 min-h-0">
        <IndustriesTree
          ref={treeRef}
          sectors={sectors}
          selectedNodeId={selectedNodeId}
          onNodeClick={handleNodeClick}
        />
      </div>
      <SubIndustryDetailPanel
        nodeId={selectedNodeId}
        onClose={handleClosePanel}
        onFocus={handleFocusNode}
      />
    </div>
  );
}
